export default __webpack_public_path__ + "static/media/clear-night.12342de7.svg";